// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__8215J","calendarButtons":"ClockData_calendarButtons__25mv1"};